import React, { useEffect, useRef, useState } from 'react';
import { Empty, Layout, Spin, Typography } from 'antd';
import { AxiosResponse } from 'axios';
import TraductorSteps from './TraductorSteps';
import TraductorContent from './TraductorContent';
import useFetch from '../../../../../hooks/useFetch';
import { FetchApiInterface } from '../../../../../interfaces/FetchApi.interface';

const { Content } = Layout;
const { Text } = Typography;

const SESSION_KEY = 'traductor_selected_rows';

interface ItemData {
  documents: any[];
  control: any | null;
}

const TraductorDetalle: React.FC = () => {
  const [items, setItems]               = useState<any[]>([]);
  const [current, setCurrent]           = useState(0);
  const [itemData, setItemData]         = useState<ItemData | null>(null);
  const [loadingItem, setLoadingItem]   = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const stepsRef                        = useRef<HTMLDivElement>(null);
  const { fetchApi }                    = useFetch();

  useEffect(() => {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (raw) {
      try { setItems(JSON.parse(raw)); } catch { setItems([]); }
    }
  }, []);

  useEffect(() => {
    const el = stepsRef.current?.querySelector(`[data-step="${current}"]`) as HTMLElement | null;
    el?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }, [current]);

  useEffect(() => {
    const item = items[current];
    if (!item?.id || !item?.assignedId) return;

    setLoadingItem(true);
    setItemData(null);

    const fetchDocs: FetchApiInterface    = { url: `/translations/documents/${item.id}`, method: 'GET' }; // todo si llega el documentObservation
    const fetchControl: FetchApiInterface = { url: `/comms/control/get_view_by_id?assId=${item.assignedId}`, method: 'GET' };

    Promise.all([fetchApi(fetchDocs), fetchApi(fetchControl)])
      .then(([docsRes, controlRes]: [AxiosResponse<any>, AxiosResponse<any>]) => {
        const documents = Array.isArray(docsRes.data) ? docsRes.data : docsRes.data?.data || [];
        const control   = controlRes.data?.status === 'success' ? controlRes.data?.data || null : null;
        setItemData({ documents, control });
      })
      .catch(() => setItemData({ documents: [], control: null }))
      .finally(() => setLoadingItem(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current, items, refreshCounter]);

  if (items.length === 0) {
    return (
      <Layout style={{ minHeight: '100vh', background: '#f5f5f5' }}>
        <Content style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Empty description='No hay comunicaciones seleccionadas' />
        </Content>
      </Layout>
    );
  }

  const mergedItem = itemData?.control
    ? { ...items[current], ...itemData.control }
    : items[current];

  return (
    <Layout style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      {/* ── Encabezado ── */}
      <div style={{
        background: '#f8f8f8',
        borderBottom: '1px solid #e8e8e8',
        padding: '16px 24px',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}>
        <Text strong style={{ fontSize: 16, display: 'block', marginBottom: 16 }}>
          Traducción de comunicaciones
        </Text>
        <TraductorSteps
          total={items.length}
          current={current}
          stepsRef={stepsRef}
          onStepClick={setCurrent}
        />
      </div>

      {/* ── Contenido ── */}
      <Content style={{ padding: 24 }}>
        {loadingItem || !itemData ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
            <Spin size="large" />
          </div>
        ) : (
          <TraductorContent
            item={mergedItem}
            documents={itemData.documents}
            loadingDocuments={false}
            onRefresh={() => setRefreshCounter(c => c + 1)}
            onCompleted={() => {
              if (current < items.length - 1) {
                setCurrent(c => c + 1);
              } else {
                window.close();
              }
            }}
          />
        )}
      </Content>
    </Layout>
  );
};

export { SESSION_KEY };
export default TraductorDetalle;
